<template>
    <div :class="classes.root">
        <!-- Header -->
        <is-label v-if="topfix"
                  :value="topfix"
                  class="_mb-0.5"
                  :dark="dark" />

        <!-- Body -->
        <div class="f">
            <!-- Avatar -->
            <div v-if="withAvatar"
                 :class="classes.avatarContainer">
                <el-avatar icon="el-icon-user-solid"
                           :class="classes.avatar" />
            </div>

            <!-- About -->
            <div :class="classes.about">
                <!-- Tag -->
                <div v-if="tags"
                     class="f space-x-0.5 space-y-0.5 f-wrap">
                    <el-tag
                        v-for="tag in tags"
                        :key="tag"
                        class="_mr-0.25 fs-0.7"
                        size="mini">
                        {{ tag }}
                    </el-tag>
                </div>

                <!-- Name -->
                <is-label :value="name"
                          :dark="dark"
                          :primary="primaryName"
                          :color="nameColor"
                          class="lh-1.5" />

                <!-- Email -->
                <is-label v-if="withEmail && isNotSameName"
                          :value="email"
                          :dark="dark"
                          class="lh-1.5"
                          tertiary />

                <!-- Organization -->
                <is-label v-if="withOrganization"
                          :value="organizationName"
                          :dark="dark"
                          class="lh-1.5"
                          tertiary />

                <!-- Position -->
                <is-label v-if="withPosition"
                          :value="positionResult"
                          :dark="dark"
                          class="lh-1.5"
                          tertiary />

                <div v-if="tagsBottom"
                     class="f-wrap space-x-0.5 space-y-0.5">
                    <el-tag 
                        v-for="tag in tagsBottom"
                        :key="tag"
                        class="f-y-center _px-0.75 font-medium text-gray-700 bg-gray-300 border-0 rounded">
                        {{ tag }}
                    </el-tag>
                </div>

                <!-- Blocked -->
                <div v-if="user"
                     class="f space-x-0.5">
                    <user-status :user="user"
                                 minimal />
                    <user-blocking-tag :user="user" />
                </div>

                <slot />
            </div>

            <!-- Actions -->
            <div class="f-center">
                <slot name="actions" />
            </div>
        </div>
    </div>
</template>

<script>
import { getName, getFullName, getEmail, getOrganizationName, getOrganizationPosition } from '@/models/users'

import UserBlockingTag from '@/components/users/UserBlockingTag'
import UserStatus from '@/components/users/UserStatus';

export default {
  components: {
    UserBlockingTag,
    UserStatus
  },
  props: {
    user: { type: Object, default: () => ({}) },
    organization: { type: Object, default: () => ({}) },
    align: { type: String, default: 'left' },
    topfix: { type: String, default: null },
    position: { type: String, default: null },
    dark: { type: Boolean, default: false },
    tags: { type: Array, default: () => [] },
    tagsBottom: { type: Array, default: () => [] },
    compact: { type: Boolean, default: false },

    primaryName: { type: Boolean, default: false },
    fullName: { type: Boolean, default: false },

    nameColor: { type: String, default: null },

    withAvatar: { type: Boolean, default: false },
    withOrganization: { type: Boolean, default: false },
    withPosition: { type: Boolean, default: false },
    withEmail: { type: Boolean, default: false }
  },
  data() {
    return {

    }
  },
  computed: {
    classes() {
      return {
        avatar: {
          '_mr-0.5': true,
          'wh-2.5 lh-2.5 fs-1': !this.compact,
          'wh-1.5 lh-1.5 fs-0.7': this.compact
        },
        avatarContainer: {
          'f-y-center': this.align === 'center'
        },
        about: {
          'w-full f-col f-x-center': true,
          'space-y-0.25': !this.compact
        }
      }
    },

    name() {
      return this.fullName ? getFullName(this.user) : getName(this.user)
    },

    email() {
      return getEmail(this.user)
    },

    organizationName() {
      return getOrganizationName(this.user)
    },

    positionResult() {
      return this.position || getOrganizationPosition({ user: this.user, organization: this.organization })
    },

    isNotSameName() {
      return this.name !== this.email
    }
  },
  methods: {
    onEdit() {
      this.$emit('edit', this.user)
    }
  }
}
</script>
